import React from "react";
import PageView from "@/pages";
import { HashRouter } from "react-router-dom";
import { DataVersionGate, TierListDataProvider } from "@/providers";

interface IAppProps {}
const App: React.FC<IAppProps> = () => {
  return (
    <React.Suspense fallback={<div className="page-loading">加载中...</div>}>
      <DataVersionGate>
        {context => (
          <TierListDataProvider {...context}>
            <HashRouter>
              <PageView />
            </HashRouter>
          </TierListDataProvider>
        )}
      </DataVersionGate>
    </React.Suspense>
  );
};

export default App;
